export default __webpack_public_path__ + "static/media/Water.557990a0.jpg";